/* istanbul ignore file */
import useAuthentication from './useAuthentication';

export default useAuthentication;
